import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCombinationGlyphSecondary from './svgs/CombinationGlyphSecondary.js';
import SvgCombinationGlyph from './svgs/CombinationGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var combinationGlyph = (props => useIcon(SvgCombinationGlyph, SvgCombinationGlyphSecondary, props));

export { combinationGlyph as default };
